import React from "react";

const PatternInsightSummary = ({ summary }) => {
  if (!summary) return null;

  return (
    <section className="mp-insight-summary" aria-labelledby="mp-insight-summary-title">
      <h2 id="mp-insight-summary-title" className="mp-insight-summary__title">
        {summary.title}
      </h2>
      <p className="mp-insight-summary__body">{summary.body}</p>
      <div className="mp-insight-summary__focus">
        <p className="mp-insight-summary__focus-label">Suggested focus</p>
        <ul className="mp-insight-summary__focus-list">
          {summary.focus.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default PatternInsightSummary;
